import { Link, useLocation } from 'react-router-dom';
import { Home, Users, Wallet, User, Sun, Moon } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

function Navigation() {
  const location = useLocation();
  const { dark, toggle } = useTheme();

  const menus = [
    { path: '/dashboard', icon: Home, label: 'Home' },
    { path: '/add-member', icon: Users, label: 'Members' },
    { path: '/wallet', icon: Wallet, label: 'Wallet' },
    { path: '/profile', icon: User, label: 'Profile' },
  ];

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 border-t shadow-lg z-50 ${
        dark ? 'bg-gray-900 border-gray-700' : 'bg-white border-gray-200'
      }`}
    >
      <div className="flex justify-around items-center py-2 max-w-md mx-auto">
        {menus.map((menu) => {
          const Icon = menu.icon;
          const isActive = location.pathname === menu.path;
          return (
            <Link
              key={menu.path}
              to={menu.path}
              className={`flex flex-col items-center px-2 py-1 ${
                isActive
                  ? 'text-blue-500'
                  : dark
                  ? 'text-gray-400'
                  : 'text-gray-500'
              }`}
            >
              <Icon size={22} />
              <span className="text-[10px] mt-1">{menu.label}</span>
            </Link>
          );
        })}

        {/* Dark / Light Toggle */}
        <button
          onClick={toggle}
          className={`flex flex-col items-center px-2 py-1 ${
            dark ? 'text-yellow-400' : 'text-gray-500'
          }`}
        >
          {dark ? <Sun size={22} /> : <Moon size={22} />}
          <span className="text-[10px] mt-1">{dark ? 'Light' : 'Dark'}</span>
        </button>
      </div>
    </div>
  );
}

export default Navigation;